import { render, staticRenderFns } from "./orgTable.vue?vue&type=template&id=6cba84f8&scoped=true&"
import script from "./orgTable.vue?vue&type=script&lang=js&"
export * from "./orgTable.vue?vue&type=script&lang=js&"
import style0 from "./orgTable.vue?vue&type=style&index=0&id=6cba84f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba84f8",
  null
  
)

export default component.exports